module.exports = __webpack_public_path__ + "static/media/Modeseven-L3n5.a0cb693c.ttf";